import _schoolSltor from '@app/redux/school/school.selector';
import _ from 'lodash';
import { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import './_style.scss';

interface ISchoolInfo {
    label?: string;
    value?: string;
    locationFullName?: string;
}
const SchoolInfo = () => {
    const orgId: string = useSelector(_schoolSltor.currentSchool);
    const listSchoolMap = useSelector(_schoolSltor.listSchoolMap);

    const currentSchoolInfo: ISchoolInfo = useMemo(
        () => listSchoolMap.get(orgId) ?? {},
        [orgId, listSchoolMap],
    );

    const showSchoolInfo = useCallback(() => {
        if (_.isEmpty(currentSchoolInfo)) return '';
        return (
            <div className="page-school-info text-muted">
                {currentSchoolInfo.label}
                <br />
                {currentSchoolInfo.locationFullName}
            </div>
        );
    }, [currentSchoolInfo]);
    return <>{showSchoolInfo()}</>;
};

export default memo(SchoolInfo);
